import React from 'react';
import { DateRow, PriceRow, TextRow, TypeRow, LinkRow, VoidButton, VoidedButton } from 'components';
import { LoadDetailSwitcher } from '../loads';
import { PermissionsList, RolePermission } from '../../utils';

export const payrollTypeEnums = {
  CREDIT: 'CREDIT',
  CHARGE: 'CHARGE',
  GROSSPROFIT: 'GROSSPROFIT',
  SERVICEFEE: 'SERVICEFEE',
  FLAT_FEE: 'FLAT_FEE',
  OTHER: 'OTHER',
}
export const payrollHead = [
  {
    name: 'loadDisplayId',
    title: 'Load ID',
    searchKey: 'LOAD_DISPLAY_ID',
    width: '110px',
    icon: 'date',
    custom: false,
  },
  { name: 'createdDate', title: 'Date', icon: 'date', type: 'date' },
  {
    name: 'type', title: 'Type',
    filterList: [
      { name: 'All', id: 'ALL' },
      { name: 'Credit', id: 'CREDIT' },
      { name: 'Charge', id: 'CHARGE' },
      { name: 'Gross Profit', id: 'GROSSPROFIT' },
      { name: 'Service Fee', id: 'SERVICEFEE' },
      { name: 'Flat Fee', id: 'FLAT_FEE' },
      { name: 'Other', id: 'OTHER' },
    ],
  },
  { name: 'amount', title: 'Amount',    searchKey: 'AMOUNT', custom: false },
  { name: 'agent', nameRow: 'firstName', title: 'Agent', custom: false },
  { name: 'office', nameRow: 'name', title: 'Office', custom: false },
  { name: 'branch', nameRow: 'name', title: 'Branch', custom: false },
  { name: 'description',    searchKey: 'DESCRIPTION',  title: 'Description', custom: false, smallSize: 6 },
  { name: 'method', title: 'Method', filterList: [
      { name: 'All', id: '' },
      { name: 'Auto', id: 'AUTO' },
      { name: 'Manual', id: 'MANUAL' },
    ]
  },
  RolePermission([PermissionsList.MANAGE_MANUAL_PAYROLL?.code]) &&
  { name: 'action',  title: 'Action', custom: false, width: '100px'},
];

export const payrollHeadAgent = [
  { name: 'id', title: 'Load ID', searchKey: 'LOAD_DISPLAY_ID', width: '110px', icon: 'date', custom: false },
  { name: 'date', title: 'Date', icon: 'date' },
  {
    name: 'type', title: 'Type',
    filterList: [
      { name: 'All', id: 'ALL' },
      { name: 'Credit', id: 'CREDIT' },
      { name: 'Charge', id: 'CHARGE' },
      { name: 'Gross Profit', id: 'GROSSPROFIT' },
      { name: 'Other', id: 'OTHER' },
    ],
  },
  { name: 'amount', title: 'Amount', custom: false },
  { name: 'agent', title: 'Agent', custom: false },
  { name: 'office', title: 'Office', custom: false },
  { name: 'branch', title: 'Branch', custom: false },
  { name: 'description', title: 'Description', custom: false, smallSize: 6 },
  { name: '', title: 'Method', custom: false },
];

export const payrollBody = (openPrimary, viewType, handleVoid) => [
  // {rowText: (item) =>  <LinkRow id={ item?.loadDisplayId} anotherLink={`/load/${item?.load}`} target={true}/>},
  {
    rowText: (item) =>
      item?.loadDisplayId ?
        <button
          style={{color:'#347AF0'}}
          className="link-btn"
          onClick={() => openPrimary(<LoadDetailSwitcher loadId={item?.load} />)}
        >
          {item?.loadDisplayId}
        </button>
        : 'N/A',
  },
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  {
    rowText: (item) => <TypeRow text={
      item?.type === 'GROSSPROFIT' ? 'Gross Profit' :
        item?.type === 'SERVICEFEE' ? 'Service Fee' :
          item?.type === 'OFFICE_EXPENSE' ? 'Office Expense' :
          item?.type === 'FLAT_FEE' ? 'Flat Fee' :
          item?.type === 'FLAT_CREDIT' ? 'Flat Credit' :
            item?.type
    } />,
  },
  {
    rowText: (item) => <div className={item?.amount < 0 ? 'negative-price' : 'positive-price'}><PriceRow info={item?.amount} minuse={item?.amount < 0} /></div>,
  },
  {
    rowText: (item) => <TextRow name={item?.agent ? `${item?.agent?.firstName} ${item?.agent?.lastName}` : 'Not Set'}
                                textWidth={12} />,
  },
  { rowText: (item) => <TextRow name={item?.office ? item?.office?.name : 'Not Set'} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.branch ? item?.branch?.name : 'Not Set'} textWidth={12} /> },
  { rowText: (item) => <TextRow name={item?.description ? item?.description : 'Not Set'} textWidth={12} /> },
  { rowText: (item) => <TypeRow text={item?.method ? item?.method : 'N/A'} textWidth={12} /> },

  viewType === 'details' && RolePermission([PermissionsList.MANAGE_MANUAL_PAYROLL?.code]) &&
  { rowText: (item) => <div>
      {item?.isVoided ?
      <VoidedButton />
        :
        item?.method === 'MANUAL' &&
          <VoidButton  handleClick={() => handleVoid(item)} />
      }
    </div>},
];

export const ACTION_TYPE = 'GET_PAYROLLS';
export const VOID_PAYROLL = 'VOID_PAYROLL';